module.exports = __webpack_public_path__ + "static/media/webmessaging.bda94a56.svg";